import React from 'react';

const LoadingSpinner = ({ size = 'medium' }) => {
  // Determine size classes based on the size prop
  const sizeClasses = {
    small: 'h-6 w-6 border-2',
    medium: 'h-10 w-10 border-3',
    large: 'h-16 w-16 border-4'
  };
  
  const spinnerClasses = `${sizeClasses[size] || sizeClasses.medium} animate-spin rounded-full border-blue-500 border-t-transparent`;
  
  return (
    <div className="flex items-center justify-center">
      <div className={spinnerClasses}></div>
    </div>
  );
};

export default LoadingSpinner; 